<!--  -->
<template>
 <div class="travelServe culturalcommoditydetailContainer">
    <div class="contrainers co">
       <crumbs detail="true"/>

       <div class="cLeft">
          <div class="topInfo">
            <div class="swiperBox">
               <swiper class="swipercontrainer1 gallery-top" :options="swiperOptionTop" ref="swiperTop">
                <swiper-slide class="swiperslide" v-for="(item,index) in imgList" :key="index">
                  <img :src="getImage(item)" alt="">
                </swiper-slide>
              </swiper>
               <swiper class="swipercontrainer2 gallery-thumbs"   :options="swiperOptionThumbs" ref="swiperThumbs">
                  <swiper-slide class="swiperslide" v-for="(item,index) in imgList" :key="index">
                    <img :src="getImage(item)" alt="">
                  </swiper-slide>
              </swiper>
            </div>

            <div class="details">
                  <div class="title">
                    <h2>{{detailparams.name}}</h2>
                    <span>{{detailparams.introduction}}</span>
                  </div>
                  <div class="price">推荐价格：<span>${{detailparams.price}}</span></div>
                  <div class="buy" @click="goBuy(detailparams.link)">购买</div>
            </div>
          </div>

          <div class="htmlCont">
              <div class="title"><span>商品详情</span><i></i></div>
              <div class="contentbox" v-html="detailparams.content">

              </div>
          </div>
             <!-- 评论 组件引入 -->
      <comment v-if="detailparams" comment-show="isCommentshow" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
       </div>
       <div class="cRight">
            <h3><span>热门推荐</span></h3>
            <ul class="tjul" id="tjul">

                <li v-for="item in dataList" :key="item.id"
                v-if="item.id != id" @click="goRecommit(item.id)">
                    <a href="javascript:;" >
                        <img :src="getImage(item.image)" alt="">
                        <div class="desc">
                            <h2>{{item.name}}</h2>
                        </div>
                    </a>
                </li>

        </ul>
        <a href="javascript:;" class="tjmore" id="tjmore"
        @click="gomore()"
        >更多&gt;</a>
       </div>
    </div>
<right-sidebar
     @pvcount="pvcount"
     :comment-count="commentTotal"
     :comment-gotop="commentOffsettop"
     :comment-show="isCommentshow"
      :title="detailparams.name"
      :image="getImage(detailparams.image)"
      :url="this.$route.fullPath"
      ref="rightSidebar"></right-sidebar>
       <go-top></go-top>
 </div>
</template>

<script>
import {getculturalcommodityListdetail, getculturalcommodityList} from '@/api/culturalcommodity/index'
import Comment from '@/components/comment/index'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import crumbs from '@/components/crumbs/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
export default {
  name: 'culturalcommoditydetail',
  components: {
    crumbs,
    swiper,
    swiperSlide,
    RightSidebar,
    goTop,
    Comment
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      swiperOptionTop: {
        // loop: true,
        // loopedSlides: 5, // looped slides should be the same
        // spaceBetween: 10
      },
      swiperOptionThumbs: {
        // loop: true,
        // loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        // centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true
      },
      id: '',
      menuId: '',
      detailparams: {},
      imgList: [],
      params: {
        page: 1,
        limit: 4,
        menuId: '',
        subjectType: null,
        productType: null,
        customTypeId: null
      },
      dataList: [],
      isCommentshow: true,
      commentTotal: '',
      commentOffsettop: '',
      pv: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$el.swiper
      const swiperThumbs = this.$refs.swiperThumbs.$el.swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  created () {
    this.id = this.$route.query.id
    this.params.menuId = this.$route.query.columnId
    this.menuId = this.$route.query.columnId
    this.getdetail()
    this.getList()
  },
  methods: {
    getdetail () {
      getculturalcommodityListdetail(this.id).then(res => {
        console.log(res)
        if (res.data.status === 200) {
          this.detailparams = res.data.data
          this.imgList = res.data.data.images.split('|')
        }
      })
    },
    getList () {
      getculturalcommodityList(this.params).then(res1 => {
        if (res1.data.status === 200) {
          this.dataList = res1.data.data.rows
        }
      })
    },
    getImage (val) {
      if (val === undefined || val === '') {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    goBuy (url) {
      window.open(url)
    },
    goRecommit (id) {
      this.$router.push({
        path: '/culturalcommoditydetail',
        query: {
          id,
          columnId: this.menuId
        }
      })
    },
    gomore () {
      this.$router.push({
        path: '/culturalcommodity',
        query: {
          columnId: this.menuId
        }
      })
    },
    pvcount (val) {
      this.pv = val
    },
    commentCount (val) {
      this.commentTotal = val
    },
    cOffsettop (val) {
      this.commentOffsettop = val
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/culturalcommodity.scss';
</style>



// WEBPACK FOOTER //
// src/view/culturalcommodity/detail.vue